import { resourceText } from 'src/app/shared/services/localization';
import { FollowupService } from './followup.service';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IdentityService } from './identity.service';
import { GlobalService } from './global.service';
import { ProfileService } from '../profile/profile/profile.service';
import { NotificationService } from './notification.service';

@Injectable({providedIn:'root'})
export class NavigationPanelService {
  panel: 'system' | 'language' | 'account' | null = null;
  photo = '';
  unread = 0;
  taskCount = 0;
  private photoUser = '';
  private previousOverflow = ''; 
  private returnFocus: HTMLElement | null = null;
  constructor(private router: Router, public identity: IdentityService, private global: GlobalService,
    private profiles: ProfileService, private notifications: NotificationService, private followups: FollowupService) {
    notifications.changed?.subscribe(() => { void this.refresh(); });
    router.events.subscribe(event => { if(event instanceof NavigationEnd) { this.close(false); void this.refresh(); } });
  }
  get notificationLabel() { return resourceText('NOTIFICATION'); }
  get name() { return [this.identity.firstName || this.global.currentFirstName, this.identity.lastName].filter(Boolean).join(' ') || this.global.currentUserName || 'Account'; }
  get initials() { return this.name.split(/\s+/).filter(Boolean).slice(0,2).map(s=>s[0]).join('').toUpperCase(); }
  toggle(panel: 'system' | 'language' | 'account') {
    if(this.panel === panel) {this.close(); return;}
    if (!this.panel) {
      this.returnFocus = document.activeElement as HTMLElement;
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    this.panel = panel;
  }
  close(focus = true) {
    if (!this.panel) return;
    this.panel = null;
    document.body.style.overflow = this.previousOverflow;
    if(focus) this.returnFocus?.focus();
  }
  private async refreshTaskCount(): Promise<void> {
    const member = this.identity.memberId;
    if (!this.identity.authenticated || !this.identity.hasTaskAssignment?.() || !member || !this.followups) {
      this.taskCount = 0;
      return;
    }
    try {
      const count = await this.followups.GetFollowupsCount(member);
      if (this.identity.authenticated && this.identity.memberId === member) this.taskCount = count || 0;
    } catch { this.taskCount = 0; }
  }
  async refresh() {
    void this.refreshTaskCount();
    const user = this.identity.authenticated ? this.identity.id || this.global.currentUserId : '';
    if(!user) {this.photo='';this.photoUser='';}
    else if(user !== this.photoUser || this.router.url.includes('myprofile')) {
      this.photoUser=user; this.photo='';
      try { const profile=await this.profiles.getProfile({id:user}); if(this.photoUser===user)this.photo=profile?.pictureUrl || ''; } catch {}
    }
    const notificationUser=user || localStorage.getItem('CSBarcodeID');
    if(!notificationUser) {this.unread=0;return;}
    try {const rows=await this.notifications.viewNotifications(notificationUser);this.unread=(rows || []).filter(row=>row.isOpen === false).length;} catch {this.unread=0;}
  }
}
